import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import integralMallDatas, { handleIntegralTsk } from '../datas/integral-mall'
import mallDatas from '../datas/mall'
import mallOrderDatas from '../datas/mall-order'

export default {
  getIntegralTaskList (ctx, data) {
    return fetch.getIntegralTaskList(data).then(res => {
      res.data.forEach(item => {
        handleIntegralTsk(item.pointsTask)
      })
      res = getTotalNumber(res)
      res.pointSummay = res.data.map(e => Number(e.totalProvide)).reduce(function (sum, number) {
        return sum + number
      }, 0)
      return res
    })
  },
  getIntegralTask (ctx, id) {
    return fetch.getIntegralTask(id).then(res => {
      handleIntegralTsk(res.data)
      return res.data
    })
  },
  getEditLogs (ctx, data) {
    return fetch.getEditLogs(data).then(res => {
      res = getTotalNumber(res)
      return res
    })
  },
  udpateIntegralTask (ctx, data) {
    return fetch.udpateIntegralTask(data).then(res => {
      return res.data
    })
  },
  disabledIntegralTask (ctx, data) {
    return fetch.disabledIntegralTask(data).then(res => {
      return res.data
    })
  },
  enabledIntegralTask (ctx, data) {
    return fetch.enabledIntegralTask(data).then(res => {
      return res.data
    })
  },
  saveIntegralGoods (ctx, data) {
    return fetch.saveIntegralGoods(data).then(res => {
      return res.data
    })
  },
  getIntegralGoodsTypes (ctx, data) {
    return fetch.getIntegralGoodsTypes(data).then(res => {
      return res.data
    })
  },
  getIntergralGoodsTypesOfAll (ctx) {
    return fetch.getIntergralGoodsTypesOfAll().then(res => {
      return res.data
    })
  },
  getIntegralGoodsGroups (ctx, data) {
    return fetch.getIntegralGoodsGroups(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsGroupList(result.data)
      return result
    })
  },
  getInsterGoodsList (ctx, data) {
    return fetch.getInsterGoodsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  // 积分商品详情页
  getIntegralGoodsDetail (ctx, data) {
    let { id, isEdit } = data
    return fetch.getIntegralGoodsDetail(id).then(res => {
      let result = res.data
      result = mallDatas.goodsDetail(result, isEdit, true)
      return result
    })
  },
  updateRankingOfIntegral (ctx, data) {
    return fetch.updateRankingOfIntegral(data).then(res => {
      return res.data
    })
  },
  integralGoodsStick (ctx, id) {
    return fetch.integralGoodsStick(id).then(res => {
      return res.data
    })
  },
  integralRecommend (ctx, id) {
    return fetch.integralRecommend(id).then(res => {
      return res.data
    })
  },
  integralCancelRecommend (ctx, id) {
    return fetch.integralCancelRecommend(id).then(res => {
      return res.data
    })
  },
  integralGoodsApproval (ctx, id) {
    return fetch.integralGoodsApproval(id).then(res => {
      return res.data
    })
  },
  integralGoodsPublish (ctx, data) {
    return fetch.integralGoodsPublish(data).then(res => {
      return res
    })
  },
  integralGoodsReject (ctx, id) {
    return fetch.integralGoodsReject(id).then(res => {
      return res
    })
  },
  integralGoodsOffShelves (ctx, id) {
    return fetch.integralGoodsOffShelves(id).then(res => {
      return res
    })
  },
  getAllMembers (ctx, data) {
    return fetch.getAllMembers(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsGroupList(result.data)
      return result
    })
  },
  deleteIntegralGoods (ctx, id) {
    return fetch.deleteIntegralGoods(id).then(res => {
      return res
    })
  },
  getIntegralGoodsDelivery (ctx, id) {
    return fetch.getIntegralGoodsDelivery(id).then(res => {
      return res
    })
  },
  getIntegralTotalConsume (ctx, id) {
    return fetch.getIntegralTotalConsume(id).then(res => {
      return res
    })
  },
  getIntegralExchangeStatistical (ctx, id) {
    return fetch.getIntegralExchangeStatistical(id).then(res => {
      return res
    })
  },
  getIntegralExchangeProgress (ctx, id) {
    return fetch.getIntegralExchangeProgress(id).then(res => {
      return res
    })
  },
  getIntegralDetail (ctx, id) {
    return fetch.getIntegralDetail(id).then(res => {
      let result = res.data
      result = mallDatas.getIntegralDetail(result)
      return result
    })
  },
  getApplyRefundPoints (ctx, id) {
    return fetch.getApplyRefundPoints(id).then(res => {
      return res
    })
  },
  getIntegralExchangeList (ctx, id) {
    return fetch.getIntegralExchangeList(id).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getIntegralExchangeList(result.data)
      return result
    })
  },
  getIntegralExchangeByUserId (ctx, id) {
    return fetch.getIntegralExchangeByUserId(id).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getIntegralExchangeByUserId(result.data)
      return result
    })
  },
  getIntegralExportExcel (ctx, id) {
    return fetch.getIntegralExportExcel(id).then(res => {
      return res
    })
  },
  getRefundPointsExportExcel (ctx, id) {
    return fetch.getRefundPointsExportExcel(id).then(res => {
      return res
    })
  },
  approvalRefundmentIntegral (ctx, id) {
    return fetch.approvalRefundmentIntegral(id).then(res => {
      return res
    })
  },
  rejectRefundmentIntegral (ctx, id) {
    return fetch.rejectRefundmentIntegral(id).then(res => {
      return res
    })
  },
  getIntegralRefundmentReason (ctx, id) {
    return fetch.getIntegralRefundmentReason(id).then(res => {
      return res.data
    })
  },
  newIntegralRefundmentReason (ctx, id) {
    return fetch.newIntegralRefundmentReason(id).then(res => {
      return res.data
    })
  },
  getRefundPointsList (ctx, id) {
    return fetch.getRefundPointsList(id).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getRefundPointsList(result.data)
      return result
    })
  },
  offTheShelf (ctx, id) {
    return fetch.offTheShelf(id).then(res => {
      return res
    })
  },
  membersPointsDetails (ctx, data) {
    return fetch.membersPointsDetails(data).then(res => {
      let result = getTotalNumber(res)
      result.data = integralMallDatas.membersPointsDetails(result.data)
      return result
    })
  },
  membersPointsSum (ctx, data) {
    return fetch.membersPointsSum(data).then(res => {
      return res.data
    })
  },
  membersPointsDetailsExport (ctx, data) {
    return fetch.membersPointsDetailsExport(data).then(res => {
      return res.data
    })
  },
  exportHistoryOfMembers (ctx, data) {
    return fetch.exportHistoryOfMembers(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  integralGoodsCancelStick (ctx, data) {
    return fetch.integralGoodsCancelStick(data).then(res => {
      return res.data
    })
  }
}
